import { useMemo } from "react";
import { isManualAccountV1 } from "../../Accounts/utilities/accountUtil";
import useExternalAccounts from "./useExternalAccounts";
import usePlaidInstitutions from "./usePlaidInstitutions";
import usePlaidLinks from "./usePlaidLinks";
const isValid = (acc) => {
    if (isManualAccountV1(acc)) {
        return true;
    }
    return acc.link !== null && acc.institution !== null;
};
/**
 * @returns A list of Plaid accounts that have been hydrated with their respective Links & Institutions, and unmodified Manual accounts
 */
const useExternalAccountsExtended = (params, config) => {
    const externalAccounts = useExternalAccounts(params, config);
    const plaidInstitutions = usePlaidInstitutions(config);
    const plaidLinks = usePlaidLinks(config);
    return useMemo(() => {
        if (externalAccounts.isLoading || externalAccounts.hasError) {
            return externalAccounts;
        }
        if (plaidInstitutions.isLoading || plaidInstitutions.hasError) {
            return plaidInstitutions;
        }
        if (plaidLinks.isLoading || plaidLinks.hasError) {
            return plaidLinks;
        }
        const mappedAccounts = externalAccounts.data.accounts
            .map((acc) => {
            if (isManualAccountV1(acc)) {
                return acc;
            }
            const link = plaidLinks.data.find((l) => l.linkId === acc.details.linkId);
            const institution = plaidInstitutions.data.institutions.find((i) => i.institutionId === acc.details.institutionId);
            return {
                ...acc,
                link: link ?? null,
                institution: institution ?? null,
            };
        })
            .filter(isValid);
        return {
            data: mappedAccounts,
            isLoading: false,
            hasError: false,
        };
    }, [externalAccounts, plaidInstitutions, plaidLinks]);
};
export default useExternalAccountsExtended;
//# sourceMappingURL=useExternalAccountsExtended.js.map